// Oeffnen/Schliessen laeuft jetzt komplett ueber das theme-eigene
// <theme-drawer>-Web-Component (gleiche Mechanik wie Warenkorb/Chat) --
// dieses Script kuemmert sich nur noch um zwei Dinge, die theme-drawer
// nicht von sich aus kennt: den aria-expanded-Zustand des Tab-Buttons
// (gleiches Muster wie header-actions.js fuer den Warenkorb-Button) und
// das Kopieren der Rabattcodes.

const DRAWER_ID = 'special-offers-drawer';

function syncAriaExpanded() {
  const drawer = document.getElementById(DRAWER_ID);
  const trigger = document.querySelector(`[aria-controls="${DRAWER_ID}"]`);
  if (!drawer || !trigger) return;
  trigger.setAttribute('aria-expanded', drawer.hasAttribute('open') ? 'true' : 'false');
}

document.addEventListener('theme-drawer:open', (event) => {
  if (/** @type {Element} */ (event.target).id !== DRAWER_ID) return;
  syncAriaExpanded();
});

document.addEventListener('theme-drawer:close', (event) => {
  if (/** @type {Element} */ (event.target).id !== DRAWER_ID) return;
  syncAriaExpanded();
});

document.addEventListener('click', async (event) => {
  const button = /** @type {HTMLElement} */ (event.target).closest('.special-offers-tab__copy');
  if (!button) return;

  const code = button.dataset.code;
  try {
    await navigator.clipboard.writeText(code);
  } catch (error) {
    const textarea = document.createElement('textarea');
    textarea.value = code;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  const originalText = button.textContent;
  button.textContent = 'Kopiert!';
  button.dataset.copied = 'true';
  setTimeout(() => {
    button.textContent = originalText;
    button.dataset.copied = 'false';
  }, 2000);
});
